import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import loadable from '@loadable/component';
// import SignedPdfPlayer from '../aws/SignedPdfPlayer';
const SignedPdfPlayer = loadable(() => import('../aws/SignedPdfPlayer'));
/**
 * Implements a preview of an Asset.  For images this is a thumb, for videos it
 * is a key frame.  For other types it might be an icon or something similar.
 * @param asset to preview.
 * @returns JSX component
 */
const AssetPdfPlayer = ({ asset, assetPoster, ...otherProps }) => {
    const key = asset?.type === 'pdf' ? 'original' : 'preview.pdf';
    return (_jsx(SignedPdfPlayer, { bucket: asset?.repository?.bucket ? asset.repository.bucket : null, path: asset?.path ? `${asset.path}/${key}` : null, bucketPoster: assetPoster?.repository?.bucket, pathPoster: assetPoster?.path ? `${assetPoster.path}/original` : null, ...otherProps }));
};
export default observer(AssetPdfPlayer);
//# sourceMappingURL=AssetPdfPlayer.js.map